module.exports = __webpack_public_path__ + "img/ayudantia_up_selected.50153fbf.svg";